import React from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "@heroui/react";

interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const TermsModal: React.FC<TermsModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      placement="center"
      backdrop="blur"
      size="2xl"
    >
      <ModalContent className="p-0 max-h-[80vh] overflow-hidden">
        <ModalHeader className="flex flex-col gap-1 p-6">
          <h2 className="text-xl font-bold">Términos y Condiciones</h2>
        </ModalHeader>
        
        <ModalBody className="p-6 overflow-y-auto max-h-[40vh]">
          <div className="space-y-4">
            <section>
              <h3 className="text-lg font-semibold mb-2">1. Aceptación de Términos</h3>
              <p className="text-sm text-gray-600">
                Al utilizar este sitio web, usted acepta cumplir y estar sujeto a los siguientes 
                términos y condiciones de uso, así como a nuestras Políticas de Privacidad. 
                Si no está de acuerdo con alguno de estos términos, le pedimos que no utilice nuestro sitio.
              </p>
            </section>
            
            <section>
              <h3 className="text-lg font-semibold mb-2">2. Uso del Servicio</h3>
              <p className="text-sm text-gray-600">
                Usted acepta utilizar este servicio únicamente para fines lícitos y de acuerdo 
                con estos Términos. Queda prohibido cualquier uso que viole leyes aplicables 
                o que pueda dañar los derechos o propiedades de Macroindustrial o terceros.
              </p>
            </section>
            
            <section>
              <h3 className="text-lg font-semibold mb-2">3. Contenido del Usuario</h3>
              <p className="text-sm text-gray-600">
                Usted es responsable de cualquier contenido que publique o comparta a través 
                de nuestros servicios. Nos reservamos el derecho de eliminar cualquier contenido 
                que consideremos inapropiado o que viole estos Términos.
              </p>
            </section>
            
            <section>
              <h3 className="text-lg font-semibold mb-2">4. Limitación de Responsabilidad</h3>
              <p className="text-sm text-gray-600">
                Macroindustrial no será responsable de daños directos, indirectos, incidentales 
                o consecuentes resultantes del uso o la imposibilidad de uso de nuestros servicios.
              </p>
            </section>
            
            <section>
              <h3 className="text-lg font-semibold mb-2">5. Modificaciones</h3>
              <p className="text-sm text-gray-600">
                Nos reservamos el derecho de modificar estos Términos en cualquier momento. 
                El uso continuado del sitio después de cualquier modificación constituye 
                aceptación de los nuevos Términos.
              </p>
            </section>
          </div>
        </ModalBody>
        
        <ModalFooter className="p-6">
          <Button color="primary" variant="light" onClick={onClose}>
            Cerrar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default TermsModal;